interface ImpactPreviewBannerProps {
  matchCount: number;
  totalCount: number;
  isLoading?: boolean;
}

export function ImpactPreviewBanner({ matchCount, totalCount, isLoading }: ImpactPreviewBannerProps) {
  const pct = totalCount > 0 ? Math.round((matchCount / totalCount) * 100) : 0;

  return (
    <div className="rounded-xl bg-gradient-to-b from-[#2A1E3D] to-[#3B2350] px-4 py-3.5">
      <p className="text-sm font-medium text-primary_on-brand">Impact preview</p>
      {isLoading ? (
        <p className="mt-1.5 text-sm text-tertiary_on-brand">Calculating impact…</p>
      ) : (
        <p className="mt-1.5 text-sm text-primary_on-brand">
          <span className="text-lg font-bold text-utility-brand-300">{matchCount}</span>{" "}
          <span className="text-xs font-medium text-tertiary_on-brand">({pct}%)</span> creators match today
        </p>
      )}
    </div>
  );
}
